import { render, staticRenderFns } from "./SsoLogin.vue?vue&type=template&id=311d6035&scoped=true&"
import script from "./SsoLogin.vue?vue&type=script&lang=ts&"
export * from "./SsoLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d6035",
  null
  
)

export default component.exports